import { Heart } from 'lucide-react';
import { useWishlist } from '@/context/WishlistContext';

export const WishlistButton = ({ product, className = '', iconClass = 'w-3.5 h-3.5', testId }) => {
  const { isInWishlist, toggleWishlist } = useWishlist();
  const saved = isInWishlist(product.id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(product);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={saved ? 'Remove from wishlist' : 'Add to wishlist'}
      aria-pressed={saved}
      className={`inline-flex items-center justify-center rounded-md transition-transform duration-150 active:scale-90 ${className}`}
      data-testid={testId || `wishlist-toggle-${product.id}`}
    >
      <Heart className={`${iconClass} transition-colors ${saved ? 'fill-red-500 text-red-500' : 'text-gray-700'}`} />
    </button>
  );
};

export default WishlistButton;
